import { createPortal } from "react-dom";
import { useSubNavSlot } from "./SubNavContext";
import "./nav.css";

// The one secondary-nav component. A page renders <SubNav .../> anywhere in its
// JSX; it portals into the slot the parent <Navbar/> renders beneath the
// primary nav, so the two read as one sticky stack. Variants:
//   text     – a line of contextual copy (reserve, contact, faq, deals, giftcard)
//   tabs     – a button group with an active item (menu section switcher)
//   scroller – horizontally-scrollable selectors + optional right slot (order)
// items entries are { id, label }.
export default function SubNav({
  variant = "text",
  children,
  items = [],
  activeId,
  onSelect,
  rightSlot,
  ariaLabel,
}) {
  const { slot } = useSubNavSlot();
  if (!slot) return null;

  let bar;
  if (variant === "tabs") {
    bar = (
      <div className="subnav subnav--tabs" role="tablist" aria-label={ariaLabel}>
        {items.map((it) => (
          <button
            key={it.id}
            type="button"
            role="tab"
            aria-selected={activeId === it.id}
            className={`subnav-tab${activeId === it.id ? " is-active" : ""}`}
            onClick={() => onSelect?.(it.id)}
          >
            {it.label}
          </button>
        ))}
      </div>
    );
  } else if (variant === "scroller") {
    bar = (
      <div className="subnav subnav--scroller">
        <div className="subnav-scroll">
          <div className="subnav-selectors">
            {items.map((it) => (
              <div className="subnav-selector" key={it.id}>
                {it.label}
              </div>
            ))}
          </div>
        </div>
        {rightSlot && (
          <div className="subnav-cart subnav-selector">{rightSlot}</div>
        )}
      </div>
    );
  } else {
    bar = <div className="subnav subnav--text">{children}</div>;
  }

  return createPortal(bar, slot);
}
